const paymentRoutes = [
  'payment-success',
  'payment-fail',
  'payment-callback-success',
  'payment-callback-fail',
];

export default defineNuxtRouteMiddleware((to) => {
  document.body.classList.remove('scroll-lock');

  if (location.host === 'pony.market') {
    setPageLayout('empty');
    if (to.path === '/') return;
    return navigateTo('/');
  }
});
